/**
 * Global JS
 * @package campbellsparent
 */


// This is how JQuery's $.ready() works.
const domReady = () => {
	const readyState = document.readyState
	return readyState === "interactive" ||
		readyState === "complete" ? Promise.resolve() : new Promise((resolve) => 
			document.addEventListener("DOMContentLoaded", resolve))
}

(function () {
    if (typeof window.CustomEvent === "function") {
        return false;
    }

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent (event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

// for hack of settimeout...
if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
        currTime = new Date().getTime();
        timeToCall = Math.max(0, 16 - (currTime - lastTime));
        lastTime = currTime + timeToCall;
        return window.setTimeout(function() { callback(currTime + timeToCall); }, 
          timeToCall);
    };
}

// for hack of settimeout...
var hackTimeout = function (callback, timeout) {
  var start_time = Date.now();
  
  (function loop() {
    var delta = Date.now() - start_time;

    if (delta >= timeout) {
      return callback();
    } else {
      window.requestAnimationFrame(loop);
    }
  })();
};

// lazyload images
const lazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    threshold: 0,
    callback_load: function(e) {
	    const img_parent_classes = e.parentNode.classList;
	    if ( img_parent_classes.contains( 'loading' ) ) {
	    	img_parent_classes.remove( 'loading' );
	    }
    }
});

// debounce so filtering doesn't happen every millisecond
function debounce( fn, threshold ) {
	var timeout;
	return function debounced() {
		if ( timeout ) {
			clearTimeout( timeout );
		}
		function delayed() {
			fn();
			timeout = null;
		}
		timeout = setTimeout( delayed, threshold || 100 );
	}
}

function getSupportedPropertyName(properties) {
    for (var i = 0; i < properties.length; i++) {
        if (typeof document.body.style[properties[i]] != "undefined") {
            return properties[i];
        }
    }
    return null;
}
const transform = ["transform", "msTransform", "webkitTransform", "mozTransform", "oTransform"];
const transformProperty = getSupportedPropertyName(transform);

/**
 * Show/hide mobile navigation menu.
 */
document.querySelector('.menu-toggle').addEventListener('click', (event) => {
	event.preventDefault();
	document.body.classList.toggle('mobile-menu-open');
});


const init = () => {


    // Only for the slider etc. to kick in and update...
    //lazyLoad.update();

    if(jQuery('.read-more').width() ) {
        jQuery('.read-more').click(function(){
            var dataOpen = jQuery(this).attr('data-open');
            jQuery('.description#'+dataOpen).toggleClass('open');
        });

        var hash = window.location.hash;
        if(hash) {
            var hashNum = hash.split('-');
            console.log(hashNum[1]);
            if(hashNum > 1){
                jQuery('#open-'+hashNum[1]).toggleClass('open');
            }
        }
    };


    jQuery('.slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: jQuery('.slider').attr('data-autoplay'),
        autoplaySpeed: 7000,
        dots: true
    });

    jQuery('.testimonial-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
    });

    jQuery('.award-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        //autoplay: true,
        //autoplaySpeed: 4000,
        cssEase: 'linear',
        //dots: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
    });

    jQuery('.slider, .award-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //console.log(nextSlide);
        lazyLoad.update();
    });

    jQuery('.slick-prev, .slick-next').on('click', function() {
        console.log("update");
        lazyLoad.update();
    });


    lazyLoad.update();


    jQuery('.a2a_button_pinterest').attr('title', 'Houzz');

	
	// Give content padding based on height of fixed header.
	/*const headerPadding = debounce(() => {
		const headerHeight = `${document.getElementsByTagName( 'header' )[0].scrollHeight}px`;
		document.body.style.paddingTop = headerHeight;
	}, 300);*/
	
	//headerPadding();
	
    //objectFitImages();
    
    

    // if (jQuery('#instafeed').length) {
    //     console.log('Instafeed element found' + document.querySelector('#instafeed'));
    //     setTimeout(()=>{
    //         dontRunYet()
    //     },3000);
    // }


    const scrollTo = function(to, duration) {
        //console.log(to, duration);
        const
        element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function(t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
        },
        animateScroll = function() {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if(currentTime < duration) {
                requestAnimationFrame(animateScroll);
            }
            else {
                element.scrollTop = to;
            }
        };
        animateScroll();
    };


    // $('.news-scrollto').on('click', function(){
    //     scrollTo('#filter-wrap', 1250);
    // });




    const $description = $(".description");



    $('.enabled').hover(function() {
      
        $description.addClass('active');

        $description.html( '<span>Step '+ $(this).attr('data-step') +'</span> - '+ $(this).attr('data-id'));

        switch( $(this).attr('data-step') ) {
            case '1':
                $description.css({left: '23px'});
                break;
            case '2':
                $description.css({left: '149px'});
                break;
            case '3':
                $description.css({left: '275px'});
                break;
            case '4':
                $description.css({left: '401px'});
                break;
            case '5':
                $description.css({left: '526px'});
                break;
            case '6':
                $description.css({left: '652px'});
                break;
        }

    }, function() {
      $description.removeClass('active');
    });

    
    
    if ($('#instafeed').length) {

        console.log('Instafeed Called');

        const instaElm = document.querySelector('#instafeed');
        const userId = instaElm.getAttribute('data-user-id');
        const accessToken = instaElm.getAttribute('data-token');
        const clientId = instaElm.getAttribute('data-client-id');
        const getBy = instaElm.getAttribute('data-get-by');
        const tagName = instaElm.getAttribute('data-tag-name');
        const showCount = instaElm.getAttribute('data-count');

        var lightbox;

        var feed = new Instafeed({
            userId: userId, 
            accessToken: accessToken, 
            clientId: clientId,
            get: getBy,
            tagName: tagName,
            resolution: 'standard_resolution',//'low_resolution',
            limit: showCount,
            //  {{link}}
            //  {{caption}}
            //  {{likes}}
            //  {{comments}}
            //  {{image}} url
            //  {{type}} 
            //  {{orientation}}
            //  <video><source src="{{model.videos.standard_resolution.url}}" type="video/mp4"></video>'+
            template:
                '<div class="insta-img" data-img="{{image}}" style="background: url({{image}}) no-repeat center center; background-size:cover;">'+
                    '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 300 300\'></svg>'+
                    '<a href="{{image}}" class="insta-over" title="{{caption}}">'+
                        '<div class="insta-inner">'+
                            '{{likes}} <i class="far fa-heart"></i>&nbsp;&nbsp;'+
                            '{{comments}} <i class="far fa-comment"></i>'+
                        '</div>'+
                    '</a>'+
                    '<i class="fab fa-instagram"></i>'+
                '</div>',
            after: function() {
                //setTimeout(() => {
                    lightBoxBuild();
                    console.log("lightbox called");
                //},8000);

                

                if (!this.hasNext()) {
                    nextButton.setAttribute('disabled', 'disabled');
                }
            }
        });
        
        feed.run();

        jQuery('#more').on('click',function() {
            lightbox.destroy();
            feed.next();

            // setTimeout(() => {
            //     lightbox = '';
            //     lightBoxBuild();
            // },1000);
        });

        function lightBoxBuild() {
            lightbox = jQuery('.insta-over').simpleLightbox({
                navText: ['<i class="fal fa-angle-left"></i>','<i class="fal fa-angle-right"></i>'],
                closeText:'<i class="fal fa-times"></i>',
                captionSelector: 'self',
                //additionalHtml: true
            });
            // jQuery('#instafeed a').click(function(e){
            //     e.preventDefault();
            // })
            console.log(lightbox);
        }

    }





    if(jQuery('.popup').length) {
        var imglightbox = jQuery('.popup a').simpleLightbox({
            navText: ['<i class="fal fa-angle-left"></i>','<i class="fal fa-angle-right"></i>'],
            closeText:'<i class="fal fa-times"></i>',
            captionSelector: 'self',
            //additionalHtml: true
        });
        console.log(imglightbox);
    }





    (function($) {


    if( $('.projects').length ) {
        updateSearch();
    }

    $(window).on('hashchange',function(){

        if( $('.projects').length ) {
            updateSearch();
        }

    });
    


    function updateSearch() {
        setTimeout(function(){
            if(window.location.hash) {
                var hash = window.location.hash.substring(1);
                //alert (hash);
                if( hash.toLowerCase() == 'upcoming' ) {
                    $('#o1-li label').trigger('click');
                } else if ( hash.toLowerCase() == 'progress' ) {
                    $('#o2-li label').trigger('click');
                } else if ( hash.toLowerCase() == 'completed' ) {
                    $('#o3-li label').trigger('click');
                }
                $('.lis').removeClass('show');
            }
        },100);
    }

         


    //scrollTo(sec7.offsetTop, 1250);

    // $('.menu-item a').click(function(e){
    //     console.log( $(this).attr('href') );
    //     var str = $(this).attr('href'); 
    //     var n = str.search("#");
    //     if( -1 != n ) {
            
    //         e.preventDefault();
    //         var hash = str.split('#');
    //         var elm = $('#'+hash[1]);

    //         console.log(elm.offset().top);

    //         scrollTo( elm.offset().top, 1250);
    //     }
    // });














        let is_filtering = false;
        /*
        * Filter
        */



        if ( parseInt( frontend_ajax.current_page ) === parseInt( frontend_ajax.max_page ) && parseInt( frontend_ajax.max_page ) > 1 ) {
            $('.nav-loop .nav-previous').hide();
            $('.nav-loop .nav-next').show();
        } else if ( parseInt( frontend_ajax.max_page ) === 1 ) { // actually IS page 1 as we incremented above...
            $('.nav-loop .nav-next').hide();
            $('.nav-loop .nav-previous').hide();
        } else if ( parseInt( frontend_ajax.current_page ) === 1 ) { // actually IS page 1 as we incremented above...
            $('.nav-loop .nav-next').hide();
            $('.nav-loop .nav-previous').show();
        } else {
            $('.nav-loop .nav-next').show();
            $('.nav-loop .nav-previous').show();
        }
        


        $('#bttn').on('click', function(e) {
            if( $('#search-s').text() != '' ) {
                $('#select').html( 'Select <i class="fal fa-angle-down"></i>' );
                $('.lis input').prop('checked', false);
                custom_projects_search( e.currentTarget, 'post', 'Project', $(this).attr('data-max-page'), $('#search-s').text() );
                $('#search-s').text('');
                $('.input-div').removeClass('blank');
            }
        });
        $('#search-s').focus( function(){
            $(this).addClass('blank');
        }).focusout( function(){
            if( $(this).html() == '' ) {
                $(this).removeClass('blank');
            }
        });
        $('#search-s').bind('keypress', function(e){
            $(this).addClass('blank');
            var code = e.keyCode || e.which;
            if(code == 13) { //Enter keycode
                e.preventDefault();
                $('#bttn').click();
            }
        })


        //$('#select-filter').on('change', function(e) {
        $('input[type=radio][name=opts]').on('change', function(e) {
            //console.log(e.currentTarget, $(this).attr('data-cat'), $(this).attr('data-max-page') );
            custom_projects_search( e.currentTarget, 'post', $(this).attr('data-cat'), $(this).attr('data-max-page'), '' );
            $('#select').html( $(this).val()+' <i class="fal fa-angle-down"></i>' );
            $('.lis').toggleClass('show');
        });
        $('.main-lst #select').on('click', function(){
            $('.lis').toggleClass('show');
        });

        // $('.main-lst').on('focusout', function(){
        //     $('.lis').toggleClass('show');
        // });


        $('.nav-loop .nav-previous, .nav-loop .nav-next').not('.posts-navigation .nav-previous, .posts-navigation .nav-next').on('click', function(e) {
            //console.log(e.currentTarget);
            custom_projects_search( e.currentTarget, 'post', $(this).attr('data-cat'), $(this).attr('data-max-page'), $(this).attr('data-search') );
        });


        $('.toPage').on('click', function(e) {
            custom_projects_search( e.currentTarget, 'post', $(this).attr('data-cat'), $(this).attr('data-max-page'), $(this).attr('data-search') );
        });


        function custom_projects_search( event_target, post_type = '', category_name = '', data_max_page = '', search_value = '') {
            //console.log('Function called');

            if (false === is_filtering) {
                is_filtering = true;
                $( '.loader-mask' ).addClass('show');
                //$('.nav-previous, .nav-next').css( 'pointer-events', 'none' );

                var filterSettings = {};

                // filterSettings.order = filter_order;
                // filterSettings.query = frontend_ajax.posts;
                filterSettings.post_type = post_type;
                filterSettings.category_name = category_name;
                filterSettings.data_max_page = data_max_page;
                filterSettings.s = search_value;

                //console.log('Page is = '+frontend_ajax.current_page);

                if ( event_target.className === 'nav-previous' ) {
                    //console.log( 'nav-previous - ' + event_target.className );
                    filterSettings.page = ++frontend_ajax.current_page;
                } else if ( event_target.className === 'nav-next' ){
                    //console.log( 'nav-next - ' + event_target.className );
                    filterSettings.page = --frontend_ajax.current_page;
                } else {
                    filterSettings.page = 1;
                }

                //console.log(filterSettings);

                filterSettings.security = frontend_ajax.ajax_nonce;
                filterSettings.action = 'custom_search';
                filterSettings.layout = $('#filter-wrap').attr('data-layout');//'tile'; //'list';

                //console.log(filterSettings);

                //console.log(frontend_ajax.ajaxurl);

                $.ajax({
                    url : frontend_ajax.ajaxurl, // AJAX handler
                    data : filterSettings,
                    dataType : 'json',
                    type : 'POST',
                    beforeSend : function ( xhr ) {
                    //  $('#misha_loadmore').text('Loading...'); // some type of preloader
                    
                    // console.log(url);
                    // console.log(filterSettings);
                    // console.log(dataType);
                    // console.log(type);
                    // console.log(data);
                    },
                    success : function( data ) {
                        if ( data ) {

                            // insert the posts to the container
                            $('#filter-wrap').html( data.content );

                            $('.nav-previous, .nav-next').attr('data-cat', category_name);
                            $('.nav-previous, .nav-next').attr('data-search', search_value);
                            //$('.nav-previous, .nav-next').attr('data-max-page', data_max_page);

                            if ( parseInt( frontend_ajax.current_page ) === parseInt( data.max_page ) && parseInt( data.max_page ) > 1 ) {
                                //$('#misha_loadmore').hide(); // if last page, HIDE the button
                                $('.nav-loop .nav-previous').hide();
                                $('.nav-loop .nav-next').show();
                            } else if ( parseInt( data.max_page ) === 1 ) { // actually IS page 1 as we incremented above...
                                $('.nav-loop .nav-next').hide();
                                $('.nav-loop .nav-previous').hide();
                            } else if ( parseInt( frontend_ajax.current_page ) === 1 ) { // actually IS page 1 as we incremented above...
                                $('.nav-loop .nav-next').hide();
                                $('.nav-loop .nav-previous').show();
                            } else {
                                $('.nav-loop .nav-next').show();
                                $('.nav-loop .nav-previous').show();
                            }

                            lazyLoad.update();
                            $( '.loader-mask' ).removeClass('show');
                            //$('.nav-previous, .nav-next').css( 'pointer-events', 'auto' );

                        } else {

                            $('#filter-wrap').html( "Sorry nothing found" );
                            // if no data, HIDE the button as well
                            $('.nav-previous').hide();
                            lazyLoad.update();
                            $( '.loader-mask' ).removeClass('show');
                            //$('.nav-previous, .nav-next').css( 'pointer-events', 'auto' );

                        }
                        is_filtering = false;
                    }
                });
            }
            return false; 
        }; // End filter function.


    })(jQuery);




    jQuery('#cv-input').change(function() {
        var filename = $('#cv-input').val().replace(/C:\\fakepath\\/i, '');
        $('#cv-file').html(filename);
    });

    jQuery('#contractor-input').change(function() {
        var filename = $('#contractor-input').val().replace(/C:\\fakepath\\/i, '');
        $('#contractor-file').html(filename);
    });






    function fixDiv() {
        if( $(window).width() >= 992 ) {
            var $div = $("#masthead");
            if ($(window).scrollTop() > $div.data("top") + 150) {
                $('#masthead').addClass('sticky-nav'); 
                $('body').css('padding-top', '148px');
            }else {
                $('#masthead').removeClass('sticky-nav');
                $('body').css('padding-top', 'initial');
            }
            if ($(window).scrollTop() > $div.data("top") + 200) {
                $('#masthead').css('top', '0px'); 
            }else {
                $('#masthead').css('top', '-148px');
            }
        }
    }
      
    $("#masthead").data("top", $("#masthead").offset().top);

    
    $(window).scroll(fixDiv);









if (document.querySelector('.istimate-tool') !== null) {



    var buildType = '';

    var iNext = document.querySelector('#iNext');
    var iPrev = document.querySelector('#iPrev');
    var iStart = document.querySelector('#iStart');
    let iPage = 1;
    let iPageSet = 1;
    var iPageMax = 9;
    var iSections = document.querySelectorAll("[id^='sec-']:not([id$='1'])");
    var iPos = document.querySelectorAll("[id^='pos-']:not([id$='1'])");
    
    //iNext.style.display = 'none';
    //iPrev.style.display = 'none';

    var submitOk = true;

    iNext.addEventListener('click', () => {
      if(iPage < iPageMax) {

        if(iPage == (iPageMax -1)) {
            checkSubmit();
            iNext.style.display = 'none';
            iPrev.style.display = 'none';
        } 
        if(submitOk) {
            document.querySelector(`#pos-${iPage}`).classList.toggle('active');
            iPage++;
            if(iPage > iPageSet) {
                iPageSet++;
                iNext.style.display = 'none';
            }
            document.querySelector(`#pos-${iPage}`).classList.toggle('active');
            document.querySelector(`#sec-${iPage}`).classList.toggle('top-0');
            if(iPage != iPageMax) {
                iPrev.style.display = 'block';
            }
        }
        
      }
    });

    iPrev.addEventListener('click', () => {
      if(iPage > 1) {
        document.querySelector(`#sec-${iPage}`).classList.toggle('top-0');
        document.querySelector(`#pos-${iPage}`).classList.toggle('active');
        iPage--;
        document.querySelector(`#pos-${iPage}`).classList.toggle('active');
        if(iPage <= 1) {
            iPrev.style.display = 'none';
        }
        iNext.style.display = 'block';
      }
      //console.log(iPage);
    });
    
    iStart.addEventListener('click', () => {
      iSections.forEach( (v,i,a) => {
        v.classList.remove('top-0');
      });
      iPos.forEach( (v,i,a) => {
        v.classList.remove('active');
      });
      iPage = 1;
      iPageSet = 1;
      document.querySelector(`#pos-1`).classList.add('active');
      iNext.style.display = 'none';
      iPrev.style.display = 'none';
      resetEstimate();
    });


    //$('#iNext, #iPrev').hide();



    var build = '';
    var finish = '';
    var period = '';
    var stories = '';

    var lotSize = 0; var selectUsed = false;
    var bedCount = 0;
    var bedSize = '';
    var kitchenCount = 0;
    var kitchenSize = '';
    var bathCount = 0;
    var bathSize = '';
    var livingCount = 0;
    var livingSize = '';
    var diningCount = 0;
    var diningSize = '';

    var startDate = 'TBA';

    var architect = '';
    var permit = '';

    var name = '';
    var phone = '';
    var email = '';
    var address = '';
    var notes = '';
    

    function resetEstimate() {
        console.log('Reset');
        $('#iestReset').click();
        $('.build-btn, .finish-btn, .period, .size-btn, .stories-btn, .architect, .permit').removeClass('active');
        $('select').prop('selectedIndex',0);

        $('.days li').removeClass('selected');

        $('input, textarea').val('');

        // Reset all vars
        build = '';
        finish = '';
        period = '';
        stories = '';

        lotSize = 0;
        bedCount = 0;
        bedSize = '';
        kitchenCount = 0;
        kitchenSize = '';
        bathCount = 0;
        bathSize = '';
        livingCount = 0;
        livingSize = '';
        diningCount = 0;
        diningSize = '';

        startDate = 'TBA';

        architect = '';
        permit = '';

        name = '';
        phone = '';
        email = '';
        address = '';
        notes = '';
    }

    $('.size-btn').on('click', function() {
        lotSize = $(this).attr('data-value');
        $('#q5ans').val( lotSize+'m<sup>2</sup>' );

        //$('.redArea').attr('class', '');
        $('.redArea').attr('class', 'redArea s-'+lotSize);

        // if(lotSize == '51-100') {
        //     console.log('Test');
        //     $('.redArea').css('transform', 'translate(37.5%, 33.7%) scale(0.25);');
        // }else if(lotSize == '101-150') {
        //     $('.redArea').css('transform', 'translate(25%, 22.5%) scale(0.5);');
        // }else if(lotSize == '151-200') {
        //     $('.redArea').css('transform', 'translate(12.5%, 11.2%) scale(0.75);');
        // }else if(lotSize == '201-250') {
        //     $('.redArea').css('transform', 'translate(0%, 0%) scale(1);');
        // }

        $('.size-btn').removeClass('active');
        $(this).addClass('active');
        if(selectUsed) {
            iNext.style.display = 'block';
        }
    });

    $('#sec-5 select').on('change', function() {
        if(lotSize != 0) {
            iNext.style.display = 'block';
        }
        selectUsed = true;
        
        //lotSize = $('.lot-size').val();             
        //$('#q5ans').val( lotSize );

        bedCount = $('.bed-count').val();
        //bedSize = $('.bed-size').val();             
        $('#q6ans').val( bedCount );// + ' ' + bedSize );
        
        kitchenCount = $('.kitchen-count').val();
        //kitchenSize = $('.kitchen-size').val();     
        $('#q7ans').val( kitchenCount );// + ' ' + kitchenSize );

        bathCount = $('.bath-count').val();         
        //bathSize = $('.bath-size').val();           
        $('#q8ans').val( bathCount );// + ' ' + bathSize );

        // livingCount = $('.living-count').val();
        // livingSize = $('.living-size').val();       $('#q9ans').val( livingCount + ' ' + livingSize );
        // diningCount = $('.dining-count').val();
        // diningSize= $('.dining-size').val();        $('#q10ans').val( diningCount + ' ' + diningSize );
        //console.log(lotSize,bedCount,bedSize,kitchenCount,kitchenSize,bathCount,bathSize,livingCount,livingSize,diningCount,diningSize);
    });

    

    $('.build').on('click', function() {
        build = $(this).find('.build-btn').attr('data-value');
        $('#q1ans').val( build );
        //iNext.style.display = 'block';
        iNext.click();
        $('.build-btn').removeClass('active');
        $(this).find('.build-btn').addClass('active');
        //buildType = $(this).attr('data-value');
        if (build == 'New') {
            $('.hideNew').css('display', 'none');
            $('.build-1').css('display', 'block');
            $('.build-2').css('display', 'none');
            period ='Modern';
        } else {
            $('.hideNew').css('display', 'block');
            $('.build-1').css('display', 'none');
            $('.build-2').css('display', 'block');
        }
    });

    $('.finish').on('click', function() {
        finish =  $(this).find('.finish-btn').attr('data-value') ;
        $('#q2ans').val( finish );
        //iNext.style.display = 'block';
        iNext.click();
        $('.finish-btn').removeClass('active');
        $(this).find('.finish-btn').addClass('active');
        if(build == 'New') {
            iNext.click();
        }
    });

    $('.period').on('click', function() {
        period = $(this).attr('data-value');
        $('#q3ans').val( period );
        //iNext.style.display = 'block';
        iNext.click();
        $('.period').removeClass('active');
        $(this).addClass('active');
    });

    $('.stories').on('click', function() {
        stories = $(this).find('.stories-btn').attr('data-value');
        $('#q4ans').val( stories );
        //iNext.style.display = 'block';
        iNext.click();
        $('.stories-btn').removeClass('active');
        $(this).find('.stories-btn').addClass('active');
    });

    $('.architect').on('click', function() {
        architect = $(this).attr('data-value');
        $('#q11ans').val( architect );
        //iNext.style.display = 'block';
        $('.architect').removeClass('active');
        $(this).addClass('active');
        if(architect == 'No') {
            iNext.click();
        }else if(architect.length > 0 && permit.length > 0) {
            //iNext.style.display = 'block';
            iNext.click();
        }
    });

    $('.permit').on('click', function() {
        permit = $(this).attr('data-value');
        $('#q12ans').val( permit );
        //iNext.style.display = 'block';
        $('.permit').removeClass('active');
        $(this).addClass('active');
        if(architect.length > 0 && permit.length > 0) {
            //iNext.style.display = 'block';
            iNext.click();
        }
    });

    var formArr = [0,0,0,0];

    function add(a, b) {
        return a + b;
    }

    $('.iest-form').on('focus', function() {
        
        if( $(this).attr('id') == 'name' ) {
            formArr[0] = 1;
        }
        if( $(this).attr('id') == 'phone' ) {
            formArr[1] = 1;
        }
        if( $(this).attr('id') == 'address' ) {
            formArr[2] = 1;
        }
        if( $(this).attr('id') == 'email' ) {
            formArr[3] = 1;
        }

        if(formArr.reduce(add, 0) == 4) {
            if( $('#name, #phone, #address, #email').val() != '' ) {
                iNext.style.display = 'block';
            }
        }
        //console.log(formArr);
    });

    

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function checkSubmit() {

        if( validateEmail( $('#email').val() ) ) {
            console.log( validateEmail( $('#email').val() ) );
            submitOk = true;
            name = $('#name').val();
            $('#q14ans').val( name );
            phone = $('#phone').val();
            $('#q15ans').val( phone );
            address = $('#address').val();
            $('#q16ans').val( address );
            email = $('#email').val();
            $('#q17ans').val( email );
            notes = $('#notes').val()
            $('#q18ans').val( notes );
        }   else {
            submitOk = false;
            iNext.style.display = 'block';
            alert( 'Please check your email address.' );
        }
        
        

        submitForm();
    };


    function submitForm() {

        var mtr2;
        var bathMtr2;
        var kitchenMtr2;

        if (build == "New") {
            if (finish == "Standard") {
                mtr2 = 2152;
                bathMtr2 = 17100;
                kitchenMtr2 = 35000;
            }else {
                mtr2 = 2537;
                bathMtr2 = 19100;
                kitchenMtr2 = 50000;
            }
        } else {
            if (finish == "Standard") {
                mtr2 = 2383;
                bathMtr2 = 17100;
                kitchenMtr2 = 35000;
            }else {
                mtr2 = 2844;
                bathMtr2 = 19100;
                kitchenMtr2 = 50000;
            }
        }

        var lotCalc = lotSize.split('-');
        var newLotCalc = Number( lotCalc[0] ) + Number( lotCalc[1] );

        var total = (mtr2 * (newLotCalc / 2)) + (bathCount * bathMtr2) + (kitchenCount * kitchenMtr2);

        var totalMax = total + (total * 0.1);

        // total = total.toFixed(0);
        // totalMax = totalMax.toFixed(0);

        $('#range').html(' <strong>$'+total.toLocaleString()+'</strong> - <strong>$'+totalMax.toLocaleString()+'</strong>' );

        $('#q19ans').val( '$'+total.toLocaleString()+' - $'+totalMax.toLocaleString() );

        var leftData = 
            '<li>Name: <strong>'+name+'</strong></li>'+
            '<li>Email: <strong>'+email+'</strong></li>'+
            '<li>Phone: <strong>'+phone+'</strong></li>'+
            '<li>Address: <strong>'+address+'</strong></li>'+
            '<li>Build Type: <strong>'+build+'</strong></li>'+
            '<li>Level of Finish: <strong>'+finish+'</strong></li>'+
            '<li>Period of Construction: <strong>'+period+'</strong></li>'+
            '<li>How Many Levels: <strong>'+stories+'</strong></li>'+
            '<li>Dwelling Size: <strong>'+lotSize+'m<sup>2</sup></strong></li>'
        ;
        var rightData = 
            '<li>Bedroom: <strong>'+bedCount+'</strong> </li>'+
            '<li>Bathroom: <strong>'+bathCount+'</strong> </li>'+
            '<li>Kitchen: <strong>'+kitchenCount+'</strong> </li>';

        // if(finish == "Alterations & Additions") {
        //     rightData += 
        //     '<li>Living: <strong>'+livingCount+'</strong> </li>'+
        //     '<li>Dining: <strong>'+diningCount+'</strong> </li>';
        // }
        
        rightData += 
            '<li>Architecturals: <strong>'+architect+'</strong></li>'+
            '<li>Planning Permit: <strong>'+permit+'</strong></li>'+
            '<li>Date Commence: <strong>'+startDate+'</strong></li>',
            '<li>Notes: <strong>'+notes+'</strong></li>'
        ;
        $('.left-side').html( leftData );
        $('.right-side').html( rightData );

        $('.wpcf7-submit').click();
        console.log('FORM SENT');
    }









    //--------------- Start Cal

    

    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();


    var data = [{}];
    //     date: year + '-' + month + '-' + (date - 1),
    //     value: 'hello'
    // }, {
    //     date: year + '-' + month + '-' + date,
    //     value: '上班'
    // }, {
    //     date: new Date(year, month - 1, date + 1),
    //     value: '吃饭睡觉打豆豆'
    // }, {
    //     date: '2016-10-31',
    //     value: '2016-10-31'
    // }];

    // inline
    var $ca = $('#one').calendar({
        // view: 'month',
        width: 330,
        height: 250,
        // startWeek: 0,
        // selectedRang: [new Date(), null],
        data: data,
        monthArray: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        date: new Date(),
        onSelected: function (view, date, data) {
            // console.log('view:' + view)
            // console.log('date:' + date)
            // console.log('data:' + (data || 'No'));

            startDate = date;
            $('#q13ans').val( startDate );

            iNext.style.display = 'block';
        },
        viewChange: function (view, y, m) {
            console.log(view, y, m);
        }
    });

    //--------------- End Cal






} // End iEstamate Tool





$('.loader').fadeOut();





} // End Dom Ready

// We'll pop this at the bottom so it runs "last"... well in run order anyways.
domReady() // Promise only resolves when the DOM is loaded
	.then(init);













(function($) {


    var roadAtlasStyles = [
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          { "saturation": -100 },
          { "lightness": -8 },
          { "gamma": 1.18 }
        ]
      }, {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            { "saturation": -100 },
            { "gamma": 1 },
            { "lightness": -24 }
          ]
      }, {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "administrative",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "transit",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "road",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "administrative",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "landscape",
          "stylers": [
            { "saturation": -100 }
          ]
      }, {
          "featureType": "poi",
          "stylers": [
            { "saturation": -100 }
          ]
          },
     ]
    
    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$el (jQuery element)
    *  @return	n/a
    */
    
    function new_map( $el ) {
        
        // var
        var $markers = $el.find('.marker');
        
        
        // vars
        var args = {
            zoom		: 9,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP,
            //styles: [{"featureType":"water","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":-78},{"lightness":67},{"visibility":"simplified"}]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"hue":"#e9ebed"},{"saturation":-90},{"lightness":-8},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":10},{"lightness":69},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"hue":"#2c2e33"},{"saturation":7},{"lightness":19},{"visibility":"on"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":-2},{"visibility":"simplified"}]}]
            styles: [{
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#444444"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 45
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#46bcec"
                                },
                                {
                                    "visibility": "on"
                                }
                            ]
                        }]
        };
        
        
        // create map	        	
        var map = new google.maps.Map( $el[0], args);
        
        
        // add a markers reference
        map.markers = [];
        
        
        // add markers
        $markers.each(function(){
            
            add_marker( $(this), map );
            
        });
        
        
        // center map
        center_map( map );
        
        
        // return
        return map;
        
    }
    
    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */

   
    
    function add_marker( $marker, map ) {

        //console.log( $marker );
        //console.log( $marker.getAttribute( 'data-stage' ) );


        //console.log( $marker.attr('data-stage') );

        var icon;
        
        if( $marker.attr('data-stage') === 'upcoming, Upcoming' ) {
            icon = {
                url: templateUrl + '/public/img/map-icon-amber.svg',
                scaledSize: new google.maps.Size(30, 43.757), // scaled size
                origin: new google.maps.Point(0,0), // origin
                anchor: new google.maps.Point(0, 0) // anchor
            }
        } else if ( $marker.attr('data-stage') === 'construction, In Progress' ) {
            icon = {
                url: templateUrl + '/public/img/map-icon-green.svg',
                scaledSize: new google.maps.Size(30, 43.757), // scaled size
                origin: new google.maps.Point(0,0), // origin
                anchor: new google.maps.Point(0, 0) // anchor
            }
        } else if ( $marker.attr('data-stage') === 'completed, Completed' ) {
            icon = {
                url: templateUrl + '/public/img/map-icon-red.svg',
                scaledSize: new google.maps.Size(30, 43.757), // scaled size
                origin: new google.maps.Point(0,0), // origin
                anchor: new google.maps.Point(0, 0) // anchor
            }
        } else if ( $marker.attr('data-stage') === 'office, Casafabrica Office' ) {
            icon = {
                url: templateUrl + '/public/img/map-icon-cf.svg',
                scaledSize: new google.maps.Size(30, 43.757), // scaled size
                origin: new google.maps.Point(0,0), // origin
                anchor: new google.maps.Point(0, 0) // anchor
            }
        }
    
        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
        // create marker
        var marker = new google.maps.Marker({
            position	: latlng,
            map			: map,
            icon       : icon
        });
    
        // add to array
        map.markers.push( marker );
    
        // if marker contains HTML, add it to an infoWindow
        if( $marker.html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html(),
                maxWidth    : 200
            });
    
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
    
                infowindow.open( map, marker );
    
            });

            if ( $marker.attr('data-stage') === 'office, Casafabrica Office' ) {
                infowindow.open( map, marker );
            }
        }
    
    }
    
    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */
    
    function center_map( map ) {
    
        // vars
        var bounds = new google.maps.LatLngBounds();
    
        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){
    
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    
            bounds.extend( latlng );
    
        });
    
        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 14 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }
    
    }
    
    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	5.0.0
    *
    *  @param	n/a
    *  @return	n/a
    */
    // global var
    var map = null;
    
    $(document).ready(function(){
    
        $('.acf-map').each(function(){
    
            // create map
            map = new_map( $(this) );
    
        });
    
    });
    
    })(jQuery);
    
    
    
    
    
    
    